import { Route } from "react-router-dom";
import PageTitle from "../components/PageTitle";
import FormElements from "../pages/Form/FormElements";
import ProFormElements from "../pages/Form/ProFormElements";
import FormLayout from "../pages/Form/FormLayout";
import ProFormLayout from "../pages/Form/ProFormLayout";
import ProtectedRouteV2 from "./ProtectedRouteV2";

const formsRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/forms/form-elements"
      element={
        <>
          <PageTitle title="Form Elements | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <FormElements />
        </>
      }
    />
    <Route
      path="/forms/pro-form-elements"
      element={
        <>
          <PageTitle title="Pro Form Elements | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <ProFormElements />
        </>
      }
    />
    <Route
      path="/forms/form-layout"
      element={
        <>
          <PageTitle title="Form Layout | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <FormLayout />
        </>
      }
    />
    <Route
      path="/forms/pro-form-layout"
      element={
        <>
          <PageTitle title="Pro Form Layout | TailAdmin - Tailwind CSS Admin Dashboard Template" />
          <ProFormLayout />
        </>
      }
    />
  </Route>
);

export default formsRoutes;
